import { render } from "./activity-prop.vue?vue&type=template&id=c9cffce6&scoped=true&ts=true"
import script from "./activity-prop.vue?vue&type=script&lang=ts"
export * from "./activity-prop.vue?vue&type=script&lang=ts"

import "./activity-prop.vue?vue&type=style&index=0&id=c9cffce6&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9cffce6"]])

export default __exports__